module.exports = "<div class=q-marg-all-xl> <div class=\"q-alert q-alert-red q-pad-vert-md q-pad-horz-xl\"> You are adding {%- warnDisplay %} or more poly bags. The maximum number of poly bags is {%- maxDisplay %}. </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/fxoReceivingScreen/html/warningModalBodyFor10PolyBag.html
// module id = 1326
// module chunks = 1